import React from 'react';
import { connect } from '@gasbuddy/react';
import { FlexGrid, Header } from '@gasbuddy/react-components';
import { Col } from 'react-bootstrap';
import Card from '../card';
import BpDateRangePicker from '../bp-date-range-picker';
import StarRatingCard from './star-rating-card';
import CategoryRatingsCard from './category-ratings-card';
import ReviewsFeedCard from './reviews-feed';
import StationPropType from '../../utils/prop-types/station';
import DateRangePropType from '../../utils/prop-types/date-range';
import styles from './styles.css';
import BPUtils from '../../../lib/bputils';

function ReputationTab({ station, dateRange }) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [stationRatings, setStationRatings] = React.useState({});
  const [stationRatingsError, setStationRatingsError] = React.useState(false);
  const [priorPeriodStationRatings, setPriorPeriodStationRatings] = React.useState({});

  React.useEffect(() => {
    if (station.id && dateRange) {
      loadRatingStats();
    }
  }, [station.id, dateRange]);

  const getStationRatings = async (stationId, startDate, endDate) => {
    const dateRangeQuery = `start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`;
    return BPUtils.api.get({
      path: `/stats/ratings/stations/${stationId}?recent_ratings_count=0&${dateRangeQuery}`,
      requestId: `stationRatings${dateRangeQuery}`,
    });
  };

  const loadRatingStats = async () => {
    setIsLoading(true);
    const { startDate, endDate } = dateRange;
    const { id: stationId } = station;
    const { start: priorPeriodStartDate, end: priorPeriodEndDate } = BPUtils.getPriorPeriod(startDate, endDate);

    try {
      const [newStationRatings, newPriorPeriodStationRatings] = await Promise.all([
        getStationRatings(stationId, startDate, endDate),
        getStationRatings(stationId, priorPeriodStartDate, priorPeriodEndDate),
      ]);

      setStationRatings(newStationRatings);
      setPriorPeriodStationRatings(newPriorPeriodStationRatings);
      setIsLoading(false);
    } catch (err) {
      setStationRatingsError(true);
      BPUtils.logError(err);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Col sm={12} md={6} className={styles.dateRangeWrapper}>
          <Header as="h4" className={styles.dateRangeHeader}>
            Date Range
          </Header>
          <BpDateRangePicker className={styles.dateRangeWidth} gTagTitle="Reputation Tab Date Range Picker" />
        </Col>
      </div>
      <FlexGrid container>
        <FlexGrid.Column mobile={12} tablet={6}>
          <Card title="STAR RATING" isLoading={isLoading} hasError={stationRatingsError}>
            <StarRatingCard
              stationRatings={stationRatings}
              priorPeriodStationRatings={priorPeriodStationRatings}
            />
          </Card>
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={6}>
          <Card title="CATEGORY RATING" isLoading={isLoading} hasError={stationRatingsError}>
            <CategoryRatingsCard categories={stationRatings.categories || []} />
          </Card>
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={12}>
          <ReviewsFeedCard />
        </FlexGrid.Column>
      </FlexGrid>
    </div>
  );
}

ReputationTab.propTypes = {
  station: StationPropType,
  dateRange: DateRangePropType,
};

ReputationTab.defaultProps = {
  station: null,
  dateRange: null,
};

const mapStateToProps = state => ({
  station: state.station,
  dateRange: state.dateRange,
  isLoading: state.loading,
});

export default connect(mapStateToProps, null)(ReputationTab);
